import {
    Modal,
    ModalBody,
    ModalContent,
    Spinner,
} from "@heroui/react";
import { BlobProvider } from "@react-pdf/renderer";
import { useMemo } from "react";
import { useResumeBuilder } from "../context";
import { ResumePDF } from "../resume-pdf";
import { ResumePDFViewer } from "./resume-pdf-viewer";

interface ResumePreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const ResumePreviewModal = ({
    isOpen,
    onClose,
}: ResumePreviewModalProps) => {
    const { resumeContent } = useResumeBuilder();

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    const renderedPDF = useMemo(
        () => (
            <BlobProvider
                document={<ResumePDF resumeContent={resumeContent} />}
            >
                {({ url, loading, error }) => {
                    // Do whatever you need with blob here
                    if (loading) {
                        return (
                            <div className="absolute top-0 left-0 flex h-full w-full items-center justify-center">
                                <Spinner className="mt-2" />
                            </div>
                        );
                    }
                    if (error) {
                        console.error(error);
                        return <div>Ein Fehler ist aufgetreten</div>;
                    }
                    if (url) {
                        return (
                            <ResumePDFViewer
                                file={url}
                                isSticky={true}
                                useWrapperHeight={true}
                                withFooter={true}
                                onClose={onClose}
                            />
                        );
                    }
                    return null;
                }}
            </BlobProvider>
        ),
        [JSON.stringify(resumeContent), onClose],
    );

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            size="4xl"
            scrollBehavior="inside"
            placement="center"
            classNames={{
                // width is calculated as a4Scale × (min(100vh − 1.5rem, 140vw) − footerHeight)
                base: "!my-3 h-[min(calc(100vh-1.5rem),140vw)] !w-[min(calc(70vh-1.05rem-40px),calc(98vw-40px))] max-h-[calc(100vh-1.5rem)] max-w-full",
                footer: "border-divider border-t-1",
            }}
            hideCloseButton={true}
            disableAnimation={true}
        >
            <ModalContent>
                <ModalBody className="rounded-xl bg-default-100 p-0">
                    {renderedPDF}
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};
